module.exports = __webpack_public_path__ + "img/mygift.04faf4e4.png";